module.exports = __webpack_public_path__ + "static/media/inactive_dashboard.12c7dd38.svg";